import Icon from '../components/Icon.vue'

Icon.register({"volume-down":{"width":384,"height":512,"paths":[{"d":"M256 88V424C256 445.4 230.1 456 215 441L126.1 352H24C10.7 352 0 341.3 0 328V184C0 170.7 10.7 160 24 160H126.1L215 71C230 56 256 66.6 256 88zM384 256C384 222.3 366.8 191.6 338 174.1 322.9 164.8 303.3 169.6 294 184.7S289.6 219.4 304.7 228.7C314.3 234.5 320 244.8 320 256A32.1-32.1 0 0 0 306.2 282.3C291.7 292.4 288.1 312.3 298.1 326.9 308.2 341.4 328.1 345 342.7 334.9 368.5 317 384 287.5 384 256z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/volume-down.js
// module id = null
// module chunks = 